import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  resetStatusMessage,
  formSetError,
  formResetError,
  getStandaloneLicense
} from "../../actions";

class Form extends Component {
  static propTypes = {
    onCancel: PropTypes.func,
    // Injected by React-Redux
    form: PropTypes.object.isRequired,
    resetStatusMessage: PropTypes.func.isRequired,
    formSetError: PropTypes.func.isRequired,
    formResetError: PropTypes.func.isRequired,
    getStandaloneLicense: PropTypes.func.isRequired
  };

  model = "build";

  componentWillMount = () => {
    const { resetStatusMessage, formResetError } = this.props;
    resetStatusMessage();
    formResetError();
  };

  submit = event => {
    event.preventDefault(); // this should be first line in order to prevent the form from being submitted if there is an error
    const { formSetError, formResetError, getStandaloneLicense } = this.props,
      ip = this.ipField.value.trim();
    let hasError = false;
    formResetError();
    if (!ip) {
      formSetError("ip");
      hasError = true;
    }
    if (!hasError) {
      getStandaloneLicense(ip);
    }
    return false;
  };

  reset = () => {
    this.ipField.value = "";
  };

  render = () => {
    const { form, onCancel } = this.props;
    return (
      <div className="ui">
        {form.hasError && (
          <div className="ui error message">
            <ul className="list">
              {form.errorFields.ip && <li>Enter an IP</li>}
            </ul>
          </div>
        )}
        <form className="ui form" onSubmit={this.submit}>
          <div
            className={"required field" + (form.errorFields.ip ? " error" : "")}
          >
            <label htmlFor="ip">IP</label>
            <input
              type="text"
              tabIndex="20"
              name="ip"
              id="ip"
              autoComplete="off"
              ref={input => (this.ipField = input)}
            />
          </div>
          <button
            id="cancelBuild"
            tabIndex="210"
            className="ui negative button"
            type="button"
            onClick={onCancel ? onCancel : this.reset}
          >
            Cancel
          </button>
          <button tabIndex="200" className="ui primary button" type="submit">
            Submit
          </button>
        </form>
      </div>
    );
  };
}

const mapStateToProps = state => ({
  form: state.ui.form
});

export default connect(
  mapStateToProps,
  {
    resetStatusMessage,
    formSetError,
    formResetError,
    getStandaloneLicense
  }
)(Form);
